(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const sliderSelector = [
    '.collection--grid-layout',
    'ul.product-grid',
    '.product-grid--block .grid-layout',
    '.tabs-product-grid .grid-layout'
  ].join(',');

  const excludedSelector = [
    '#ProductGridContainer',
    '.main-collection-product-grid',
    '.collection-wrapper',
    'swiper-component',
    '.swiper-wrapper',
    '.cart-drawer'
  ].join(',');

  const getItems = (slider) =>
    Array.from(slider.children).filter((item) =>
      item.querySelector?.('.card-product, .card-wrapper, [class*="card-product"]')
    );

  const shouldEnhance = (slider) => {
    if (!mobileQuery.matches) return false;
    if (slider.dataset.osMobileProductSlider === 'true') return false;
    if (slider.closest(excludedSelector)) return false;
    return getItems(slider).length > 1;
  };

  const setActiveDot = (slider, dots, index) => {
    dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === index);
      dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
    });
  };

  const getActiveIndex = (slider, items) => {
    const sliderLeft = slider.getBoundingClientRect().left;
    let closestIndex = 0;
    let closestDistance = Infinity;

    items.forEach((item, index) => {
      const distance = Math.abs(item.getBoundingClientRect().left - sliderLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  };

  const enhanceSlider = (slider) => {
    if (!shouldEnhance(slider)) return;

    const items = getItems(slider);
    slider.dataset.osMobileProductSlider = 'true';
    slider.classList.add('os-mobile-product-slider');

    const dotsWrap = document.createElement('div');
    dotsWrap.className = 'os-mobile-product-slider-dots';
    dotsWrap.setAttribute('aria-hidden', 'true');

    const dots = items.map((item, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'os-mobile-product-slider-dot';
      dot.addEventListener('click', () => {
        item.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
      dotsWrap.appendChild(dot);
      return dot;
    });

    slider.insertAdjacentElement('afterend', dotsWrap);
    setActiveDot(slider, dots, 0);

    let ticking = false;
    slider.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          setActiveDot(slider, dots, getActiveIndex(slider, items));
          ticking = false;
        });
      },
      { passive: true }
    );
  };

  const init = () => {
    if (!mobileQuery.matches) return;
    document.querySelectorAll(sliderSelector).forEach(enhanceSlider);
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  mobileQuery.addEventListener?.('change', init);

  const observer = new MutationObserver(() => init());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
